<template>
	<div>
		<az-toolbar>
			<template #actions>
				<botao-primario
					nome-botao="Novo"
					icone="add_circle"
					@click="abrirFecharModalNovoTipoDocumento"
					v-az-auth="permissoes.tipoDocumentoCriar"
				></botao-primario>
			</template>
			<template #simpleSearch>
				<az-search
					:filter="filtro"
					simple-search-placeholder="Buscar por tipo"
					@simple-search="buscarTipoDocumentoListagemPorFiltro"
					@remove-filter="removerFiltros"
					v-az-auth="permissoes.tipoDocumentoListar"
					@clear="limparBuscaListagemPorFiltro"
				></az-search>
			</template>
		</az-toolbar>
		<az-container class="listagem">
			<tipo-documento-listagem
				:tipos="tipoDocumentoListagem"
				:total-paginas="totalPaginasListagem"
				:total-itens="totalItensListagem"
				:paginacao="paginacaoListagem"
				@paginar="setPaginacaoTipoDocumentoListagem"
				@resetar-page="resetarPaginaTipoDocumentoListagem"
				@recarregar-listagem-tipo-documento="carregarTipoDocumentoListagem"
			></tipo-documento-listagem>
		</az-container>
		<novo-tipo-documento
			:exibir="exibirModalNovoTipoDocumento"
			@fechar-modal="abrirFecharModalNovoTipoDocumento"
			@recarregar-listagem-tipo-documento="carregarTipoDocumentoListagem"
		></novo-tipo-documento>
	</div>
</template>

<script>
import Paginacao from '@/core/store/default/paginacaoListagem'
import TipoDocumentoListagem from '@/views/pages/configuracao/tipo-documento/listagem/TipoDocumentoListagem.vue'
import { actionTypes, mutationTypes } from '@/core/constants'
import BotaoPrimario from '@/views/components/BotaoPrimario.vue'
import NovoTipoDocumento from '@/views/pages/configuracao/tipo-documento/novo-tipo/NovoTipoDocumento.vue'

export default {
	name: 'tipo-documento',
	components: { NovoTipoDocumento, BotaoPrimario, TipoDocumentoListagem },
	data() {
		return {
			tipoDocumentoListagem: [],
			totalPaginasListagem: 0,
			totalItensListagem: 0,
			paginacaoListagem: Paginacao(['dataCadastro'], 25, 'DESC'),
			exibirModalNovoTipoDocumento: false,
		}
	},
	computed: {
		filtro: {
			get() {
				return this.$store.state.configuracao.tipoModeloDocumento.filtroListagem
			},
			set() {
				this.$store.commit(mutationTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.SET_FILTRO_LISTAGEM)
			},
		},
	},
	async mounted() {
		await this.carregarTipoDocumentoListagem()
	},
	beforeDestroy() {
		this.$store.commit(mutationTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.RESET_FILTRO_LISTAGEM)
		this.resetarPaginaTipoDocumentoListagem()
	},
	methods: {
		async carregarTipoDocumentoListagem() {
			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.BUSCAR_TIPOS_MODELO_DOCUMENTO_LISTAGEM_PAGINADA,
			)

			this.tipoDocumentoListagem = itens
			this.totalPaginasListagem = totalPages
			this.totalItensListagem = totalElements
		},
		async buscarTipoDocumentoListagemPorFiltro(searchText) {
			if (searchText) this.filtro.nome.value = searchText.trim()

			this.resetarPaginaTipoDocumentoListagem()
			await this.carregarTipoDocumentoListagem()
		},
		async removerFiltros(propriedade) {
			if (this.filtro[propriedade]) {
				this.filtro[propriedade].value = this.filtro[propriedade].default
			}

			await this.carregarTipoDocumentoListagem()
		},
		limparBuscaListagemPorFiltro() {
			this.$store.commit(mutationTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.RESET_FILTRO_LISTAGEM)
		},
		setPaginacaoTipoDocumentoListagem(paginacao) {
			this.$store.commit(mutationTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.SET_PAGINACAO_LISTAGEM, paginacao)
			this.carregarTipoDocumentoListagem()
		},
		resetarPaginaTipoDocumentoListagem() {
			this.$store.commit(mutationTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.RESET_PAGINACAO_LISTAGEM)
		},
		abrirFecharModalNovoTipoDocumento() {
			this.exibirModalNovoTipoDocumento = !this.exibirModalNovoTipoDocumento
		},
	},
}
</script>

<style scoped lang="stylus"></style>
